// src/App.js
import React from 'react';


const SpaceDiv = () => {
  return (
      <div style={{margin:'120px'}}></div>
  );
};

export default SpaceDiv
